let IntentosPost2 = 0;
const PostArchivo = (url, file, file2, content, resp) => {
    let data = new FormData();
    data.append('archivo', file);
    data.append('planilla', file2);
    data.append('Contenido', JSON.stringify(content));

    fetch(url, {
        method: 'POST', 
        body: data,
        /* credentials: "same-origin" */})
    .then(response => {
        response.text().then(respuesta);
        function respuesta(data) {
            resp (data);
        }
    },error => {
        IntentosPost2++;
        (IntentosPost2 > 5) ? IntentosPost2 = 0 : PostArchivo(url, file, content, (respuesta) => {
            resp(respuesta)
        })
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    })
}

export default PostArchivo;


// WEBPACK FOOTER //
// ./src/shared/PostArchivo.jsx